import React from 'react';
import { ContentProvider } from './common/provider/ContentProvider';
import { ContactSales } from './common/pages/ContactSales/ContactSales';
import { Trial } from './common/pages/Trial/Trial';
import { TrialContentProvider } from './common/provider/TrialContentProvider';
import { FORM_TYPES } from './common/consts';
import ModalShell from './common/pages/Trial/TrialShell';

function App({ modal, hero }: { modal?: boolean; hero?: boolean }) {
  const trial =
    window.LPFormData?.formType === FORM_TYPES.TRIAL || window.LPFormData?.formType === FORM_TYPES.DIRECTBUY;

  return (
    <div className="App">
      {modal ? (
        <ModalShell />
      ) : trial ? (
        <TrialContentProvider>
          <Trial isHero={hero} />
        </TrialContentProvider>
      ) : (
        <ContentProvider>
          <ContactSales />
        </ContentProvider>
      )}
    </div>
  );
}
export default App;
